import { render, staticRenderFns } from "./QuestionnaireSidebarStep.vue?vue&type=template&id=2c39508b&scoped=true&lang=pug"
import script from "./QuestionnaireSidebarStep.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireSidebarStep.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireSidebarStep.vue?vue&type=style&index=0&id=2c39508b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39508b",
  null
  
)

export default component.exports